<ng-container *ngIf="item" [ngSwitch]="getComponent(item.widget)">
  <ng-container *ngSwitchDefault>
    <div d-component-r [is]="getComponent(item.widget)" [data]="item"> </div>
  </ng-container>
</ng-container>
